import { BASE_API_URL, handleAPIResponse } from './Base';

export async function getObservationData(stationId) {
  const response = await fetch(`${BASE_API_URL}/observations/${stationId}/data`)
  return await handleAPIResponse(response)
}

